import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {RewardGeneratorModel} from "../reward-generator/RewardGeneratorModel";

export class FireflyModel extends BaseObject {

    constructor() {
        super();

        this._level = 0;
        this._delayTime = 0;
        this._resetTime = 1;
        this._cooldownTime = 0;

        this._density = "1*D(3)+2";
        this._interval = "1*D(3)+2";
        this._quantity = "1*D(3)+2";

        this._generators = [];
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get delayTime() {
        return this._delayTime;
    }

    set delayTime(value) {
        this._delayTime = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }

    get cooldownTime() {
        return this._cooldownTime;
    }

    set cooldownTime(value) {
        this._cooldownTime = value;
    }

    get density() {
        return this._density;
    }

    set density(value) {
        this._density = value;
    }

    get interval() {
        return this._interval;
    }

    set interval(value) {
        this._interval = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get generators() {
        return this._generators;
    }

    set generators(value) {
        this._generators = value;
    }

    valid() {
        if (!Number.isInteger(this.level) || this.level < 0) {
            return false;
        }

        if (!Number.isInteger(this.delayTime) || this.delayTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime <= 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldownTime) || this.cooldownTime < 0) {
            return false;
        }

        if (this.density === "") {
            return false;
        }

        if (this.interval === "") {
            return false;
        }

        if (this.quantity === "") {
            return false;
        }

        if (this.generators.length === 0 || this.generators.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FireflyModel());
        } else if (target instanceof FireflyModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FireflyModel, {
    _uid: alias("uid", Schema.primitive()),
    _enabled: alias("enabled", Schema.primitive()),
    _level: alias("level", Schema.primitive()),
    _delayTime: alias("delay_time", Schema.primitive()),
    _resetTime: alias("reset_time", Schema.primitive()),
    _cooldownTime: alias("cooldown_time", Schema.primitive()),

    _density: alias("fn_density", Schema.primitive()),
    _interval: alias("fn_interval", Schema.primitive()),
    _quantity: alias("fn_quantity", Schema.primitive()),

    _generators: alias("generators", list(RewardGeneratorModel.schema())),
});